var map = {
	"./activity.svg": "4b34",
	"./alert.svg": "8546",
	"./arrow-2-blue.svg": "aae31",
	"./arrow-2.svg": "83ad",
	"./arrow-down.svg": "5c3c",
	"./arrow-up.svg": "5200",
	"./arrow-with-circle.svg": "bbf4",
	"./background-twism-gradient.svg": "03c4",
	"./background-twism.svg": "8889",
	"./bank-bg.svg": "b4c6",
	"./bank.svg": "a10a",
	"./check.svg": "5236",
	"./clock-blue.svg": "6366",
	"./coins.svg": "2cc5",
	"./currency.svg": "02cd",
	"./dashboard.svg": "5451",
	"./dollar-symbol.svg": "9548",
	"./edit.svg": "8399",
	"./error.svg": "2804",
	"./filter.svg": "8e90",
	"./gift-coin.svg": "1055",
	"./gift.svg": "bcab",
	"./globe.svg": "22b8",
	"./horn.svg": "123b",
	"./lock-blue.svg": "e995",
	"./logout.svg": "24fc",
	"./map-pin.svg": "c7b2",
	"./navigation.svg": "16eb",
	"./offers.svg": "2a18",
	"./pencil-blue.svg": "2402",
	"./percent.svg": "7db8",
	"./phone.svg": "9855",
	"./pin-plus.svg": "95a2",
	"./pin.svg": "958c",
	"./plus-blue.svg": "ae04",
	"./plus.svg": "8c7a",
	"./search.svg": "0930",
	"./settings.svg": "cbdc",
	"./share-app.svg": "9dd5",
	"./shopping.svg": "d632",
	"./success.svg": "17bf",
	"./transfer.svg": "7b18",
	"./twism-dark.svg": "e4b9",
	"./twism-full-logo-light.svg": "e5f1",
	"./twism-full-logo.svg": "c47b",
	"./twism-light.svg": "282c",
	"./twism-logo-white.svg": "031f",
	"./twism-new-logo.svg": "6522",
	"./twism.svg": "1d0a",
	"./user.svg": "7393",
	"./users.svg": "3a68",
	"./warning.svg": "248b",
	"./withdrawal-failed.svg": "40c2",
	"./withdrawal-processing.svg": "9975",
	"./withdrawal-success.svg": "9f59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";